/**
 * Per-datum bar styling through the Recharts `shape` prop (the replacement for
 * the deprecated `Cell`): highlight, signed colours and per-row tones.
 */
import React from 'react';
import { Rectangle } from 'recharts';
import type { BarShapeProps } from 'recharts';

export interface BarCellStyle {
  fill: string;
  fillOpacity: number;
}

/**
 * A Bar `shape` that styles each rectangle from its datum and index. The datum
 * is the chart row the caller passed to the chart, typed by the caller.
 */
export function barCellShape<Datum>(
  style: (datum: Datum, index: number) => BarCellStyle,
): (props: BarShapeProps) => React.ReactElement {
  const BarCell = (props: BarShapeProps): React.ReactElement => {
    const datum: Datum = props.payload;
    return <Rectangle {...props} {...style(datum, props.index)} />;
  };
  return BarCell;
}
